import { render, staticRenderFns } from "./customerDetall.vue?vue&type=template&id=a9db6a9a&scoped=true&"
import script from "./customerDetall.vue?vue&type=script&lang=js&"
export * from "./customerDetall.vue?vue&type=script&lang=js&"
import style0 from "./customerDetall.vue?vue&type=style&index=0&id=a9db6a9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9db6a9a",
  null
  
)

export default component.exports